import { render, staticRenderFns } from "./ChemicalPermit.vue?vue&type=template&id=6e46bd0c"
import script from "./ChemicalPermit.vue?vue&type=script&lang=js"
export * from "./ChemicalPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports